import { useDispatch } from 'react-redux';
import React, { useEffect, useState } from "react";

import { Alert, Button, Card, Checkbox, Col, Divider, Form, Grid, Input, message, Row, Segmented, Space, Spin, theme, Typography } from "antd";
import LockLogo from "../../assets/png/lock.png"
import '../../style/auth.css'
import { signinKioskPin, } from "../../service/api";
import { useAuth } from "../../context/authContext";
import { useNavigate } from "react-router-dom";
import LoginPage from "../../assets/png/login_side.png"

import { ArrowLeft, LockKeyhole, LockKeyholeOpen } from "lucide-react";
import StaffActionModal from "./StaffActionModal";
import ParentActionModal from "./ParentActionModal";
import { useSelector } from "react-redux";
import VerifyLock from "./VerifyLock";
import { getDashboard } from '../../feature/staffs/dashboard/DashboardSlice';


function SigninKiosk() {
    const dispatch = useDispatch();
    const { dashboardData, isLoading } = useSelector((state) => state.dashboards);
    const { isLock } = dashboardData || {};

    const [open, setOpen] = useState(false);

    const [actionData, setActionData] = useState(null)
    const [otp, setOtp] = useState(null);
    const [signLoading, setSignLoading] = useState(false)
    const [form] = Form.useForm()
    const navigate = useNavigate()


    useEffect(() => {
        dispatch(getDashboard())
    }, [])

    // const loginApi = userType === "Admin" ? adminLogin : staffLogin

    const isStaff = actionData?.userType === "staff";

    const onFinish = async () => {
        setSignLoading(true);
        try {
            const res = await signinKioskPin({ pin: otp });
            if (res.status === 201) {
                setActionData(res.data.data)
                setOpen(true)
                setOtp(null)
                form.resetFields()
            }

        } catch (error) {
            console.log(error)
        } finally {
            setSignLoading(false);
        }
    };

    const onFinishFeild = (value) => {
        message.error("All field is required !")
        console.log(value)
    }



    return (
        <section className="login_section">
            {isLoading ? <Spin fullscreen /> :
                <>
                    <Row>
                        {isStaff ? (
                            <StaffActionModal actionData={actionData} open={open} onClose={() => setOpen(false)} />
                        ) : (
                            <ParentActionModal actionData={actionData} open={open} onClose={() => setOpen(false)} />
                        )}
                        <Col sm={24} md={24} lg={16} className="image_section">
                            <img src={LoginPage} />
                        </Col>
                        <Col sm={24} md={24} lg={8} className="login_pin">
                            <Card>
                                <div className="pin_validate gradient-border">
                                    <img src={LockLogo} />
                                    <h2>Sign In Kiosk</h2>
                                    <p>For Staff or Student clock in/ Break/Clock out</p>
                                </div>
                                <Divider orientation="center"  ><span className="light_color">Enter 4 digit PIN</span></Divider>
                                <Form
                                    form={form}
                                    name="normal_login"
                                    onFinish={onFinish}
                                    onFinishFailed={onFinishFeild}
                                    layout="vertical"
                                >

                                    <Form.Item
                                        name="pin"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Please enter your pin "
                                            },
                                            {
                                                pattern: /^[0-9]+$/,
                                                message: "Only numbers are allowed!",
                                            },
                                        ]}
                                    >
                                        <center>
                                            <Input.OTP length={4} onChange={(value) => {
                                                setOtp(value);
                                                form.setFieldsValue({ pin: value });
                                            }} />
                                        </center>
                                    </Form.Item>
                                    <Form.Item >
                                        <Button className="pin_btn" size="large" block="true" loading={signLoading} htmlType="submit">
                                            Continue...
                                        </Button>

                                    </Form.Item>
                                </Form>
                            </Card>
                        </Col>
                    </Row>
                    <div className="back_btn">
                        <Button disabled={isLock} icon={<ArrowLeft size={20} />} shape="circle" onClick={() => navigate(-1)}></Button>
                        {!isLock && <Alert
                            style={{ width: "65%", padding: "10px" }}
                            message="Access Control Reminder"
                            description="Please ensure that all modules are locked for unauthorized staff. Do not forget to lock the access restrictions."
                            type="info"
                            showIcon
                        />

                        }
                        <VerifyLock />
                    </div>
                </>}
        </section>
    );
}

export default SigninKiosk